import styled from "styled-components";

export const Button = styled.button`
  margin-top: 10px;
`;
